import "./ToggleThemeButton.css";
import React, { useId } from "react";
import { useSelector } from "react-redux";
import { appThemeEnum } from "../../classes/enums/AppThemeEnum";
import { useUser } from "../../classes/contexts/UserContext";
import { useKeyboardActivation } from "../../hooks/useKeyboardActivation";

function ToggleThemeButton() {
  const currentTheme = useSelector(state => state.application.theme);
  const { updateUserTheme } = useUser();
  const id = useId();
  
  const toggle = () => {
    // TODO: Change to Light when we have a light theme
    const newTheme =
      currentTheme === appThemeEnum.Light ? appThemeEnum.Dark : appThemeEnum.Dark;
    updateUserTheme(newTheme);
  };

  const handleKeyDown = useKeyboardActivation(toggle);

  return (
    <button
      className="App-toggle-theme-switch"
      onClick={toggle}
      onKeyDown={handleKeyDown}
      type="button"
      aria-pressed={currentTheme === appThemeEnum.Dark}
      aria-label="Toggle theme"
      id={`toggle-theme-button-${id}`}
    >
      <span className="App-toggle-theme-slider" />
    </button>
  );
}

export default ToggleThemeButton;
